import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import TradeDetailWindow from '../components/TradeDetailWindow';
import HedgeCalculatorWindow from '../components/HedgeCalculatorWindow';
import FloatingWindow from '../components/FloatingWindow';
import '../styles/Trades.css';

const TradeDetailPage = () => {
  const { tradeId } = useParams();
  const [hedgeCalcWindows, setHedgeCalcWindows] = useState([]);
  const [nextZIndex, setNextZIndex] = useState(2000);

  const handleOpenHedgeCalculator = (positionData, hedgeStrategyId = null) => {
    const existingWindow = hedgeCalcWindows.find(
      w => w.positionId === positionData.positionId && w.hedgeStrategyId === hedgeStrategyId
    );
    if (existingWindow) {
      setHedgeCalcWindows(prev =>
        prev.map(w => w.id === existingWindow.id ? { ...w, zIndex: nextZIndex } : w)
      );
      setNextZIndex(prev => prev + 1);
      return;
    }

    const windowId = `hedge-${tradeId}-${positionData.positionId}-${hedgeStrategyId || 'new'}-${Date.now()}`;
    const newWindow = {
      id: windowId,
      tradeId,
      positionId: positionData.positionId,
      positionData,
      hedgeStrategyId,
      zIndex: nextZIndex,
      position: { x: 150, y: 150 },
      size: { width: 585, height: 600 }
    };
    setHedgeCalcWindows(prev => [...prev, newWindow]);
    setNextZIndex(prev => prev + 1);
  };

  const handleHedgeCalcClose = (windowId) => {
    setHedgeCalcWindows(prev => prev.filter(w => w.id !== windowId));
  };

  const handleHedgeCalcFocus = (windowId) => {
    setHedgeCalcWindows(prev =>
      prev.map(w => w.id === windowId ? { ...w, zIndex: nextZIndex } : w)
    );
    setNextZIndex(prev => prev + 1);
  };

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ padding: '8px 16px', borderBottom: '1px solid #30363d' }}>
        <Link to="/trades" style={{ color: '#58a6ff', textDecoration: 'none', fontSize: '14px' }}>
          ← Back to Trades
        </Link>
      </div>

      <TradeDetailWindow
        tradeId={tradeId}
        refreshTrigger={0}
        onPositionCountChange={() => {}}
        onWindowResize={() => {}}
        onOpenHedgeCalculator={handleOpenHedgeCalculator}
      />

      {hedgeCalcWindows.map((win) => (
        <FloatingWindow
          key={win.id}
          id={win.id}
          title={`Hedge Calculator - Trade ${win.tradeId}`}
          onClose={handleHedgeCalcClose}
          initialPosition={win.position}
          initialSize={win.size}
          zIndex={win.zIndex}
          onFocus={handleHedgeCalcFocus}
        >
          <HedgeCalculatorWindow
            tradeId={win.tradeId}
            positionData={win.positionData}
            hedgeStrategyId={win.hedgeStrategyId}
          />
        </FloatingWindow>
      ))}
    </div>
  );
};

export default TradeDetailPage;
